/**
 * Legacy Function - Mailchimp List Subscription Handler
 * Since we are not using Mailchimp anymore, we will deprecate this handler soon. 
 * If you need to use it, you'll need to install the "jsonp" dependency manually. 
 * @param  {Object} formData  Object containing the form data (email, consent, etc.)
 * @return {Object}           The Mailchimp response containing the result (error or success) and the message to display.
 */

//import jsonp from 'jsonp'

export function mailchimpHandler(formData) {
  return (
    new Promise((resolve) => {
      let mailchimpResponse = ''
      /* jsonp(`//${process.env.GATSBY_MAILCHIMP_URL}/subscribe/post-json?u=${process.env.GATSBY_MAILCHIMP_ACCOUNT}&id=${process.env.GATSBY_MAILCHIMP_LIST_ID}&${queryString(formData)}`, { param: 'c' }, (err, data) => {
        mailchimpResponse = data
        resolve(mailchimpResponse)
      }) */
    }).then((mailchimpResponse) => {
      return mailchimpResponse
    })
  )
}

function queryString(data) {
  return Object.keys(data).map(
    (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
  ).join('&')
}